// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"85":"724859793d224e2b464d","534":"6e4188f64331d99147ec","650":"ad3bb1f4a6272afa26b2"}[chunkId] + ".css";
};